
import type { PropType } from 'vue';

import { defineComponent } from 'vue';

import type {
  Feed,
  GenericObject,
} from '@/types';

import {
  FEED_MAX_REVENUE_PER_DAY_STRATEGIES_MAP,
  FEED_STATUS_DISABLED,
  FEED_STATUSES_MAP,
} from '@/libs/consts';

import useUser from '@/composable/useUser';

import useStatisticsLink from '@/composable/useStatisticsLink';

export default defineComponent({
  props: {
    feed: {
      type: Object as PropType<Feed>,
      required: true,
    },
    statisticsFilters: {
      type: Object as PropType<keyof GenericObject>,
      default: () => ({}),
    },
    iconSize: {
      type: Number,
      default: 14,
    },
    showComment: {
      type: Boolean,
      default: true,
    },
  },
  setup() {
    const { activeUser: user } = useUser();

    const { encodeStatisticsFilters } = useStatisticsLink();

    return {
      FEED_MAX_REVENUE_PER_DAY_STRATEGIES_MAP,
      FEED_STATUS_DISABLED,
      FEED_STATUSES_MAP,
      user,
      encodeStatisticsFilters,
    };
  },
});
